// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_models__Atd from "../../../../packages/models/Atd.js";
import * as Buhta_models__Protocol_v1_mel from "../../../../packages/models/generated/Protocol_v1_mel.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as ReasonReactUpdate from "../../../../vendored/reason-react-update/ReasonReactUpdate.js";

function useDays(initialDaysOpt, param) {
  const initialDays = initialDaysOpt !== undefined ? initialDaysOpt : [
      undefined,
      undefined
    ];
  const match = ReasonReactUpdate.useReducer([
    /* Default */ 0,
    initialDays
  ], (function (action, param) {
    const match = param[1];
    const endDay = match[1];
    const startDay = match[0];
    const stage = param[0];
    switch (action.TAG) {
      case /* TransitionTo */ 0 :
        return {
          TAG: /* Update */ 0,
          _0: [
            action._0,
            [
              startDay,
              endDay
            ]
          ]
        };
      case /* OnDaySelected */ 1 :
        const day = action._0;
        switch (stage) {
          case /* Default */ 0 :
          case /* StartDaySelecting */ 1 :
            break;
          case /* EndDaySelecting */ 2 :
            return {
              TAG: /* Update */ 0,
              _0: [
                /* Default */ 0,
                [
                  startDay,
                  Caml_option.some(day)
                ]
              ]
            };
          case /* StartMonthSelecting */ 3 :
          case /* EndMonthSelecting */ 4 :
            return /* NoUpdate */ 0;
        }
        return {
          TAG: /* Update */ 0,
          _0: [
            Belt__Belt_Option.isSome(endDay) ? /* Default */ 0 : /* EndDaySelecting */ 2,
            [
              Caml_option.some(day),
              endDay
            ]
          ]
        };
      case /* Set */ 2 :
        const match$1 = action._0;
        return {
          TAG: /* Update */ 0,
          _0: [
            stage,
            [
              match$1[0],
              match$1[1]
            ]
          ]
        };
    }
  }));
  const match$1 = match[0];
  const match$2 = match$1[1];
  return [
    match$1[0],
    [
      match$2[0],
      match$2[1]
    ],
    match[1]
  ];
}

const CalendarRangePickerForm = {
  useDays: useDays
};

function encode(param) {
  return Buhta_models__Atd.encode(Buhta_models__Protocol_v1_mel.write_crm__new_ticket_action, param);
}

const TicketForm = {
  encode: encode
};

export {
  CalendarRangePickerForm,
  TicketForm,
}
/* Buhta_models__Atd Not a pure module */
